module.exports = __webpack_public_path__ + "static/media/report_check_green.b94cc333.svg";